import { Currency } from "@redotech/money/currencies";
import * as z from "zod/v4";

export const getWidgetsSummaryMetrics = {
  name: "getWidgetsSummaryMetrics" as const,
  input: z.null(),
  output: z.object({
    // TODO(paul): use MoneySchema
    salesGeneratedByWidgets: z.object({
      shopCurrency: z.enum(Currency),
      value: z.number().optional(),
    }),
    checkoutConversionRateOverLast30Days: z.number().optional(),
    // TODO(paul): use MoneySchema
    revenueLiftPerOrder: z.object({
      shopCurrency: z.enum(Currency),
      value: z.number().optional(),
    }),
  }),
};
